"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ALL_ASSIGNATION_OFFER_CLAIM_STATUSES = exports.ACTIVE_ASSIGNATION_OFFER_CLAIM_STATUSES = void 0;
const assignation_offer_claim_status_enum_1 = require("../models/assignation-offer-claim-status.enum");
exports.ACTIVE_ASSIGNATION_OFFER_CLAIM_STATUSES = [assignation_offer_claim_status_enum_1.AssignationOfferClaimStatus.Accepted, assignation_offer_claim_status_enum_1.AssignationOfferClaimStatus.Confirmed];
exports.ALL_ASSIGNATION_OFFER_CLAIM_STATUSES = [
    assignation_offer_claim_status_enum_1.AssignationOfferClaimStatus.Accepted,
    assignation_offer_claim_status_enum_1.AssignationOfferClaimStatus.Confirmed,
    assignation_offer_claim_status_enum_1.AssignationOfferClaimStatus.Declined,
    assignation_offer_claim_status_enum_1.AssignationOfferClaimStatus.Cancelled,
];
//# sourceMappingURL=assignation-offer-claim-statuses.js.map